<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <span class="text-blue-400 items-center justify-center fas fa-route">
                </span>
            </div>
        </template>
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Send to</label>
            <ui-dropdown menu-class="p-3 w-" placement="right">
                <template #default="{ open,close }">
                    <ui-input v-model="to"
                              placeholder="Email address/phone number..."
                              class="xl:col-span-12"
                              @focus="purchaseOrder.supplier?open():null"
                              @input="error = false; purchaseOrder.supplier?open():null"
                    ></ui-input>
                </template>
                <template #menu="{ close }">
                    <div class="p-1 max-h-64 overflow-y-auto w-full z-30">
                        <div v-if="sentTos.length > 0">
                            <div class="ml-0 text-xs font-medium text-gray-400 mb-1">Previously used for&nbsp;<span
                                class="font-semibold text-gray-500">"{{ purchaseOrder.supplier }}"</span>
                            </div>
                            <div class="ml-1 text-xs mb-1 mr-3">
                                <div
                                    v-for="sentTo in sentTos"
                                    class="flex items-center space-x-1 text-left w-full rounded-md px-2 py-1 focus:outline-none cursor-pointer text-gray-600 hover:bg-blue-50"
                                    @click="to = sentTo;close()"
                                    v-text="sentTo"
                                >
                                </div>
                            </div>
                        </div>
                        <div v-if="sentTos.length === 0">
                            <div
                                class="text-gray-400 text-xs font-italic p-3 justify-center align-middle items-center flex">
                                Nothing previously sent to&nbsp;<span
                                class="font-semibold text-gray-500">"{{ purchaseOrder.supplier }}"</span>
                            </div>
                        </div>
                    </div>
                </template>
            </ui-dropdown>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="busy" @click="send"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import PackageContactSearch from "../../contacts/PackageContactSearch.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {uuid} from "../../../utils";
import {PurchaseOrder} from "@models";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiDropdown from "../../ui/UiDropdown.vue";

export default {
    components: {UiDropdown, UiTextarea, UiButtonNew, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Send Purchase Order'
        },
        button: {
            type: String,
            default: 'Send Purchase Order'
        },
        name: '',
        contacts: {},
        purchaseOrder: Object,
    },
    data() {
        return {
            to: '',
            busy: false,
            error: false,
            sentTos: [],
        }
    },
    computed: {
//        sentToSearch() {
//            const query = this.to.split(/[^A-Za-z0-9.-]+/);
//            if (query.length) {
//                return this.sentTos.filter((sentTo) => {
//                    return query.every((token) => {
//                        return sentTo.toLowerCase().includes(token) && sentTo.trim()
//                    });
//                })
//            }
//            return this.sentTos;
//        },
    },
    methods: {
        contactSelected(e) {
            this.form.to = e.to;
        },
        async send() {
            this.busy = true;
            let id = uuid();
            let response = await this.purchaseOrder.send({to: this.to})
            this.busy = false;
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Invalid email')) {
                    this.error = 'ERROR: Cannot determine how to handle "' + this.to + '" - is this a valid email address or phone number?'
                    return
                }
            } else {
                this.to = '';
            }
            await this.handle(id, this)
        },
    },
    async mounted() {
        if (this.purchaseOrder.supplier) {
            this.sentTos = await PurchaseOrder.sentTos(this.purchaseOrder.supplier);
        }
    }
}
</script>
